<template>
  <q-card>
    <q-card-section class="q-pa-none">
      <div class="row">
        <q-tabs
          v-model="tab"
          no-caps
          vertical
          dense
          class="col-auto text-grey"
          active-color="primary"
          indicator-color="primary"
          v-if="!isEmail && hasProfiler"
        >
          <q-tab name="profiler">
            <span>Perfil</span>
            <span>Salvo</span>
          </q-tab>

          <q-separator />

          <q-tab name="timeline">
            <span>Atendimento</span>
          </q-tab>
        </q-tabs>

        <q-separator vertical />

        <q-tab-panels
          v-model="tab"
          animated
          class="col"
        >
          <q-tab-panel
            name="profiler"
            v-if="hasProfiler"
          >
            <div>
              <div class="col justify-start">
                <div
                  class="q-px-xs"
                  v-for="(profiler, index) in profilers"
                  :key="index"
                >
                  <strong><span>{{ profiler.label }}:</span></strong>
                  <span class="q-ml-sm">{{ profiler.value }}</span>
                </div>
              </div>
              <div class="q-px-xs row">
                <div class="col-auto q-mt-xs q-mr-md ">
                  <strong><span>Perfil:</span></strong>
                </div>
                <div class="column">
                  <div
                    class="q-mt-xs"
                    v-for="tree in getTree"
                    :key="tree"
                  >
                    <q-badge
                      color="primary"
                      outline
                    >
                      {{ tree }}
                    </q-badge>
                  </div>
                </div>
              </div>
            </div>
          </q-tab-panel>

          <q-tab-panel name="timeline">
            <DetailsCall
              v-if="isVoice"
              :call-id="attendance.attendanceId"
              :agent-id="attendance.agentId"
              :queue-id="attendance.queueId"
              :phone="attendance.contactNumber"
              :created-at="attendance.createdAt"
              :direction="attendance.direction"
            />

            <div v-else-if="isChat">
              <DetailsChat :attendance-id="attendance.attendanceId" />
            </div>

            <div v-else-if="isEmail">
              <DetailsEmail :attendance-id="attendance.attendanceId" />
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import DetailsCall from '@/components/DetailsCall'
import DetailsChat from '@/components/DetailsChat'
import DetailsEmail from '@/components/DetailsEmail'

export default {
  components: {
    DetailsCall,
    DetailsChat,
    DetailsEmail
  },

  props: {
    attendance: {}
  },

  data () {
    return {
      tab: 'timeline'
    }
  },

  computed: {
    isVoice () {
      return this.attendance.type === 'Voz'
    },

    isChat () {
      return this.attendance.type === 'Texto'
    },

    isEmail () {
      return this.attendance.type === 'Email'
    },

    profilers () {
      const vm = this
      return vm.attendance.profilers
    },

    getTree () {
      const vm = this
      const tree = vm.attendance.tree
      return tree ? tree.split(',') : ['-']
    },

    hasProfiler () {
      const vm = this
      const tree = vm.attendance.tree
      const profilers = vm.attendance.profilers
      return Boolean(tree) || Boolean(profilers && Object.keys(profilers).length)
    }
  }
}

</script>
